import React, { useState, useEffect } from 'react';
import './JoinUs.css';

const JoinUs = () => {
  const [email, setEmail] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowPopup(true);
    setEmail('');
  };

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showPopup]);

  return (
    <>
      <section className="joinUs">
        <div className="joinCotainer">
          <h2 className="joinHeading">
            Join Our Newsletter to get
            <br />
            the Latest Discounts!
          </h2>

          <form className="emailForm" onSubmit={handleSubmit}>
            <div className="inputWrap">
              <input
                type="email"
                placeholder="Your email"
                aria-label="Your email"
                className="emailInput"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <button type="submit" className="btnSubmit">
                Subscribe
              </button>
            </div>
          </form>
        </div>
      </section>

      {showPopup && (
        <div className="popupOverlay">
          <div className="popupBox">
            <h3>Thank You!</h3>
            <p>
              You’ve successfully subscribed to our newsletter.
              <br />
              Stay tuned for exclusive offers!
            </p>
            <button
              className="popupBtn"
              onClick={() => setShowPopup(false)}
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default JoinUs;
